import { defineComponent as _defineComponent } from 'vue'
import ToggleButton from '@/ui-components/ToggleButton.vue';
import ResetButton from '@/components/buttons/ResetButton.vue';

import { useFilterStore } from '@/helpers/composables/useStores';
import { FilterCollection, FilterName } from '@/stores/filter.store';
import { isFilterActive as filterActive } from '@/helpers/filter-helper';

import { CollectionType } from '../../enums/collection-type';
import { OfferMonetizationType, OfferMonetizationTypes } from '@/interfaces/titles';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterMonetizationTypes',
  props: {
    collectionType: null,
    currentFilters: null
  },
  setup(__props: any) {

const props = __props as {
	collectionType: CollectionType;
	currentFilters: FilterCollection;
};

const { toggle } = useFilterStore();



const options =
	// not all monetization options shoudl be shown, there are some
	// that should not be selected
	OfferMonetizationTypes.filter(f => f.visible) // show only visible types
		.sort((a, b) => a.priority - b.priority); // order by priority ASC

function isFilterActive(filterName: FilterName, value: any) {
	return filterActive(filterName, value, props.currentFilters);
}

function clicked(monetizationType: OfferMonetizationType) {
	const selectedState = isFilterActive('monetization_types', monetizationType) ? 0 : 1;
	toggle({
		filterName: 'monetization_types',
		value: monetizationType,
		selectedState,
	});
}

return { __sfc: true,toggle, props, options, isFilterActive, clicked, ToggleButton, ResetButton }
}

})